<template>
  <div class="newTopic" v-loading="loading">
    <div class="breadcrumb">
      话题管理 > 新增
      <el-button class="right_f" @click="cancel">取消</el-button>
      <el-button class="right_f" type="primary" @click="submitCreateTopic"
        >确定</el-button
      >
    </div>
    <div class="topicDetail">
      <el-form
        ref="topicForm"
        :model="topicForm"
        :rules="rules"
        label-width="100px"
        class="topic-form"
      >
        <el-form-item label="话题头像" prop="coverImage">
          <!-- <el-upload :action="actionUrl" :with-credentials="true" accept="image/*" name="uploadFile" type="drag"
                  :show-file-list="false" :on-error="handleError" :on-success="handleCoverUploadSuccess">
                  <i class="el-icon-upload"></i>
                  <div class="el-dragger__text">将文件拖到此处，或 <em>点击上传</em></div>
               </el-upload>
               <img v-if="topicForm.coverImage" class="upload-preview" :src="topicForm.coverImage" alt="" /> -->
          <SUpload
            :value="[topicForm.coverImage]"
            accept="image/*"
            type="drag"
            :size="50"
            :show-file-list="false"
            :on-success="handleCoverUploadSuccess"
          />
          <div class="supload-tips">
            建议尺寸73*73，大小≤50KB，优先webp次选png
          </div>
        </el-form-item>

        <el-form-item label="详情页图片">
          <SUpload
            :value="[topicForm.detailImage]"
            accept="image/*"
            type="drag"
            :size="50"
            :show-file-list="false"
            :on-success="handleDetailUploadSuccess"
          />
          <div class="supload-tips">
            建议尺寸375*184，大小≤50KB，优先webp次选png
          </div>
          <!-- <el-upload
            :action="actionUrl"
            :with-credentials="true"
            accept="image/*"
            name="uploadFile"
            type="drag"
            :show-file-list="false"
            :on-error="handleError"
            :on-success="handleDetailUploadSuccess"
          >
            <i class="el-icon-upload"></i>
            <div class="el-dragger__text">
              将文件拖到此处，或 <em>点击上传</em>
            </div>
          </el-upload>
          <img
            v-if="topicForm.detailImage"
            class="upload-preview"
            :src="topicForm.detailImage"
            alt=""
          /> -->
        </el-form-item>

        <el-form-item label="话题名称" prop="title">
          <el-input
            v-model.trim="topicForm.title"
            :maxlength="50"
            placeholder="不超过100个字符"
          ></el-input>
        </el-form-item>

        <el-form-item label="摘要" prop="summary">
          <el-input
            v-model.trim="topicForm.summary"
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            :maxlength="500"
            placeholder="不超过500个字符"
          >
          </el-input>
        </el-form-item>

        <el-form-item label="类别" prop="categoryId">
          <el-select
            v-model="topicForm.categoryId"
            placeholder="请选择"
            style="width: 180px"
          >
            <el-option
              v-for="item in categories"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <select-school
          :schObj="topicForm.schObj"
          @changeVal="handleSchoolChange"
        ></select-school>
      </el-form>
    </div>
  </div>
</template>

<script>
import selectSchool from "../../common/selectSch.vue";

const LOG_TAG_NEW_TOPIC = "[TopicManage]";

export default {
  components: { selectSchool },
  data() {
    return {
      loading: false,
      actionUrl:
        this.$util.domain +
        "/adminapi/v1/basicTools/upload/one?uploadImageType=5",
      categories: [],
      topicForm: {
        coverImage: "",
        detailImage: "",
        title: "",
        summary: "",
        categoryId: "",
        schObj: {
          applicableCampus: "0",
          shieldedSchools: [],
          openedSchools: [],
        },
      },
      rules: {
        coverImage: [
          { required: true, message: "请上传话题头像", trigger: "change" },
        ],
        title: [
          { required: true, message: "请输入话题名称", trigger: "blur" },
          { min: 1, max: 50, message: "不超过50个字符", trigger: "blur" },
        ],
        summary: [
          { required: true, message: "请输入摘要", trigger: "blur" },
          { min: 1, max: 500, message: "不超过500个字符", trigger: "blur" },
        ],
        categoryId: [
          { required: true, message: "请选择类别", trigger: "change" },
        ],
      },
    };
  },
  mounted() {
    this.getClasses();
  },
  methods: {
    isRequestSuccess(errorCode) {
      return errorCode === 10000 || errorCode === 0;
    },
    cancel() {
      history.go(-1);
    },
    handleSchoolChange(schObj) {
      this.topicForm.schObj = schObj;
    },
    getClasses() {
      this.$http({
        method: "POST",
        url: this.$util.domain + "/adminapi/v2/operate/topic/categories",
      })
        .then((res) => {
          const result = (res && (res.body || res.data)) || {};
          if (!this.isRequestSuccess(result.error)) {
            this.$message.error(result.message || "获取类别失败");
            return;
          }
          const list = result.data || [];
          this.categories = list.map((item) => ({
            label: item.name,
            value: String(item.id),
          }));
        })
        .catch((err) => {
          console.error(LOG_TAG_NEW_TOPIC, "getClasses error", err);
          this.$message.error("获取类别失败");
        });
    },
    handleError(response) {
      if (response && response.status === 403) {
        location.href = "/#";
      }
      this.$message.error("上传失败");
    },
    handleCoverUploadSuccess(response) {
      if (!this.isRequestSuccess(response && response.error)) {
        this.$message.error((response && response.message) || "上传失败");
        return;
      }
      this.topicForm.coverImage = response.data || "";
    },
    handleDetailUploadSuccess(response) {
      if (!this.isRequestSuccess(response && response.error)) {
        this.$message.error((response && response.message) || "上传失败");
        return;
      }
      this.topicForm.detailImage = response.data || "";
    },
    buildCreateTopicRootUnids() {
      const schObj = this.topicForm.schObj;
      if (schObj.applicableCampus === "1") {
        return schObj.openedSchools
          .map((item) => Number(item.rootUnid))
          .filter((item) => item > 0);
      }
      return schObj.shieldedSchools
        .map((item) => Number(item.rootUnid))
        .filter((item) => item > 0);
    },
    submitCreateTopic() {
      if (
        this.topicForm.schObj.applicableCampus === "1" &&
        this.topicForm.schObj.openedSchools.length === 0
      ) {
        this.$message.warning("请添加应用学校");
        return;
      }
      if (!String(this.topicForm.categoryId || "").trim()) {
        this.$message.warning("请选择类别");
        return;
      }
      this.$refs.topicForm.validate((valid) => {
        if (!valid) {
          return;
        }
        const body = {
          id: 0,
          categoryId: Number(this.topicForm.categoryId),
          title: this.topicForm.title,
          coverImage: this.topicForm.coverImage,
          detailImage: this.topicForm.detailImage || "",
          summary: this.topicForm.summary,
          topicStatus: 2,
          publishNum: 0,
          applicableCampus: Number(this.topicForm.schObj.applicableCampus),
          rootUnids: this.buildCreateTopicRootUnids(),
          initParticipateNum: "",
          initialNum: 0,
        };
        this.loading = true;
        this.$http({
          method: "POST",
          url: this.$util.domain + "/adminapi/v2/operate/topic/add",
          body: JSON.stringify(body),
        })
          .then((res) => {
            const result = (res && (res.body || res.data)) || {};
            if (!this.isRequestSuccess(result.error)) {
              this.$message.error(result.message || "新增失败");
              return;
            }
            this.$message.success("新增成功");
            location.href = "/#/yunying/topic/topicManage";
          })
          .catch((err) => {
            console.error(LOG_TAG_NEW_TOPIC, "submitCreateTopic error", err);
            this.$message.error("新增失败");
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
  },
};
</script>

<style scoped>
.newTopic .topicDetail {
  padding: 18px 20px;
}

.newTopic .topic-form {
  max-width: 760px;
}

.upload-preview {
  margin-top: 10px;
  width: 72px;
  height: 72px;
  border-radius: 4px;
  object-fit: cover;
}

/* 上传提示文案（与编辑弹窗 topicManage.vue 保持一致） */
.supload-tips {
  margin-top: 6px;
  color: #8391a5;
  font-size: 12px;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// newTopic.vue?3a49b61a